import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
var appApisGTW = null;
if (!configuration['reports']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8090')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8091')
  });
}
/*let appApisGTW = axios.create({
  baseURL: process.env.VUE_APP_SVC_APIS_HOST//"https://crun-itc-dp-audience-intercorp-qmuzefzuga-uc.a.run.app"
})*/

setupInterceptors(appApisGTW);
var headers = {
  'Content-Type': 'application/json'
};
var CONTROLLER_NAME = '/reports';
var DOMAIN_ACCESS = '/aud_analytics';
export default {
  getReports: function getReports() {
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS, "/get_reports"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  generateParam: function generateParam() {
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS, "/generate_param"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  },
  generateParamQualityShared: function generateParamQualityShared() {
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.post("".concat(CONTROLLER_NAME).concat(DOMAIN_ACCESS, "/generate_param/quality_shared"), body, {
      headers: headers
    }).then(function (response) {
      return response.data;
    });
  }
};